import { useLaneContext } from '../../context/LaneContext';
import DynamicQuickSelect from './DynamicQuickSelect';
import StaticQuickSelect from './StaticQuickSelect';

const QuickSelect = () => {
  const { view } = useLaneContext();

  return view == 'static' ? <StaticQuickSelect /> : <DynamicQuickSelect />;
};

export default QuickSelect;
